
$(document).ready(function () {
    CallService("/api/air/RetrieveCurrentUserInfo", null, true, "RetrieveCurrentUserInfoComplete");
    if (window.location.href.indexOf("search") > -1) {
        
        if (!$('#divLoading').hasClass('hide')) {
            HideLoadingDialog();
        } 
    }
    
    document.onkeydown = function (evt) {
        var keyCode = evt ? (evt.which ? evt.which : evt.keyCode) : event.keyCode;
        if (keyCode == 13) {
            
            if ($("#txtSearchOnFacet").val() && $("#txtSearchOnFacet").is(":focus")) {
                submitSearchFormOnFacetPanel();
                $("#txtSearch").val("");
                ShowLoadingDialog();
            }

            if ($("#txtSearch").val() && $("#txtSearch").is(":focus")) {
                submitSearchForm();
                $("#txtSearchOnFacet").val();
                ShowLoadingDialog();
            }            
        }
    }

    $("#searchResults .article").each(function () {
        
        if (    $(this).children('.typeCategory').text().trim().indexOf('Events') === -1 &&
                $(this).children('.typeCategory').text().trim().indexOf('AIR in the News') === -1 &&
                $(this).children('.summary').text().length > 250    ) {
            
            //$(this).children('.summary').text($(this).children('.summary').text().trim().substring(0, 280));
            //$(this).children('.summary').text($(this).children('.summary').text().trim().replace(/^(.{250}[^\s]*).*/, "$1"));
            
            var trimmedString = $(this).children('.summary').text().trim().substr(0, 280);
            trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
            $(this).children('.summary').text(trimmedString);

            $(this).children('.readMoreDots').removeClass('hide');
        }
        
        $(this).removeClass("hide");
        $(this).next().removeClass("hide");
    });

    $(".facetLink").each(function (index) {
        if ($(this).hasClass("active")) {
            $(this).parent("li").siblings().children('.facetLink').addClass("disabled").attr("href", "javascript: void(0)");
            $(this).prepend("<i class='fa fa-times-circle'></i>");                        
        }        
    });

    $(".facetLink.disabled").on("click", function (e) {
        e.preventDefault();
    });

    $(".facetLink.clickable").on("click", function (e) {
        if (!$(this).hasClass("disabled")) {
            $('html, body').animate({ scrollTop: 0 }, 100);

            setTimeout(function () {
                ShowLoadingDialog();
            }, 100);        
        }
        
    });
    
    var url_string = window.location.href
 
    var sortOrder;

    //if (url.searchParams.get("SelectedSortOrder") !== null) {
    //    sortOrder = url.searchParams.get("SelectedSortOrder");
    //}
    
    //if (url.searchParams.get("SortBy") !== null) {
    //    sortOrder = url.searchParams.get("SortBy");
    //}
    
    //if (sortOrder !== null && sortOrder !== undefined) {
    //    if (sortOrder.toLowerCase() === 'relevance') {
    //        $(".relevance").addClass("highlightSelected");
    //    } else {
    //        $(".date").addClass("highlightSelected");
    //    }
    //} else {
    //    $(".date").addClass("highlightSelected");
    //}
    
    if ($(window).width() < 750) {
        $(".facetTitle").attr("data-status", "close");

        if ($(".facetTitle span").hasClass("triangleLeft")) {
            $(".facetTitle span").removeClass("triangleLeft").addClass("triangleRight");
        }
    }

    $("ul.pagination li a, #spanSortOrder a").on("click", function () {
        $('html, body').animate({ scrollTop: 0 }, 100);

        setTimeout(function () {
            ShowLoadingDialog();
        }, 100);      
    });
    
    var searchText = $(".searchedFor").html();

    if (searchText) {
        if (searchText.trim() !== "") {
            $(".headerSearchBox").addClass("searchActive");
            $("#txtSearch, #txtSearchOnFacet").val(searchText);
            $("#searchResults").highlight(searchText);
            $(".searchBox .searchTextClear, .searchActive .searchTextClear").css("display", "inline-block");
        }
    }
    
});

$(document).on("click", ".facetTitle", function () {
    if ($(this).attr("data-status") === "close") {
        $(this).next().slideDown(400);
        $(this).children(".triangleRight").addClass("triangleLeft").removeClass("triangleRight");
        $(this).attr("data-status", "open");
    } else {
        $(this).next().slideUp(400);
        $(this).children(".triangleLeft").addClass("triangleRight").removeClass("triangleLeft");
        $(this).attr("data-status", "close");
    }
});

function DisplaySearchResults() {
    pageSize = 10;
    selectedFacets = new Array();
    selectedGroups = new Array();
    searchType = $("#contentHeader").text();

    if (searchType.toLowerCase() === "keyword" || searchType.toLowerCase() === "search results") {
        searchType = "keyword";
        //get the search text from the session.
        searchText = $.trim(sessionStorage.SearchText);
        sessionStorage.removeItem('SearchText');
        if (searchText && searchText !== '') {
            AddVirtualViewInAnalytics('/SearchResults?q=' + searchText);
        }
        orderBy = { Name: 'relevancy', Value: 'desc' };
        $("#txtFacetSearch").val(searchText);
    }
    else if (searchType.toLowerCase() === "events") {
        searchText = '';
        orderBy = { Name: 'date', Value: 'asc' };
    }
    else {
        searchText = '';
        orderBy = { Name: 'date', Value: 'desc' };
    }

    HighlightSortBy();

    BindFacetsAndResults();
}

function DisplaySearchResultsFromCookie(searchCookie) {

    pageSize = searchCookie.pageSize;
    selectedFacets = searchCookie.selectedFacets;
    selectedGroups = searchCookie.selectedGroups;
    searchType = searchCookie.search.Value;

    //Set the sort order from cookie
    orderBy = searchCookie.orderBy;
    HighlightSortBy();

    if (searchType.toLowerCase() === "keyword" || searchType.toLowerCase() === "search results") {
        searchType = "keyword";
        searchText = searchCookie.search.Name;
        if (searchText && searchText !== '') {
            AddVirtualViewInAnalytics('/SearchResults?q=' + searchText);
        }
        $("#txtFacetSearch").val(searchText);
    }
    else {
        searchText = searchCookie.search.Name;
        $("#txtFacetSearch").val(searchText);
    }

    if (searchCookie.selectedFacetObjects !== null) {
        selectedFacetObjects = searchCookie.selectedFacetObjects;

        for (var i = 0; i < selectedFacetObjects.length; i++) {
            var facet = selectedFacetObjects[i];

            if (i === 0) {
                $('#divSelectedCategories').html('');
                //add the clear all link to facets list, only when the first facet is added
                var item = $('<br /><div class="facetLink" align="right" id="divFacetRemoveAll">' +
                'Clear All<span style="display:block; height:5px" /></div>')
                .show();

                $('#divSelectedCategories').append(item);
                //on click attach the event handler
                AttachDivFacetRemoveAllClickHandler();
                $(".clearFilter").css("display", "inline-block");
            }

            //add the clicked faced to selected facets list
            item = $('<div class="facetLink" data-gname="' + facet.facetGroupName + '" data-name="' + facet.facetName + '"  data-facetpath="' + facet.facetPath + '"   data-facetindex="' + facet.facetIndex + '" data-gindex="' + facet.facetGroupIndex + '" id="divSelected_' + facet.facetIndex + '" ><img src="/images/icons/delete.png" alt="Remove" /> ' +
                 '<b>' + facet.facetName + '</b><span style="display:block; height:5px" /></div>')
                .show();

            $('#divSelectedCategories').prepend(item);
        }
    }
    $('.facetLink').click(function () {
        RemoveFacet($(this).data('facetindex'), $(this).data('facetpath'));
    });

    $(document).on('click', '.facetLinkMarginLeft', function () {

        RemoveFacet($(this).data('index') + "0", $(this).data('path'));
    });

    BindFacetsAndResults();
}

$(document).keydown(function (event) {
    if (event.keyCode === 13) { //enter key
        if ($("input:focus").attr("id") === 'txtFacetSearch') {
            //FacetSearchClicked();
            return false;
        }
        
    }
});

function GetFacets() {
    ShowLoadingDialog();
    if (processingRequest) return;
    processingRequest = true;
    $("#divFacets").hide();
    if (!searchText) searchText = '';
    var search = { Name: searchText, Value: searchType };
    CallService("GetFacets", { "search": search, "selectedFacets": selectedFacets }, true, "GetFacetsComplete");
}

function GetFacetsComplete(result) {
    processingRequest = false;
    ShowNotification(result.notification);
    if (result.notification.NotificationType === 0) {
        $("#divFacets").html('');
        $("#facetsTemplate").tmpl({ "FacetGroups": result.GetFacetsResult }).appendTo("#divFacets");

        $.each(selectedGroups, function () {
            //$("#divFacetGroup_" + this).html('Category Selected');
            var t = $("#divSelectedCategories :data('gindex=" + this + "')")[0];

            var ind = $(t).attr("data-gindex");
            var fp = $(t).attr("data-facetpath");

            var selectedItem = '<span class="facetLinkMarginLeft" data-path="' + fp + '" data-index="' + ind + '">' + $(t).data('name');
            selectedItem += '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve" style="width: 15px; height: 15px;" class="removeFacet"><circle fill="#6D6D6D" cx="10" cy="10" r="10"/><path fill="#FFFFFF" d="M12.2,10l3.3-3.3c0.6-0.6,0.6-1.6,0-2.2c-0.6-0.6-1.6-0.6-2.2,0L10,7.8L6.7,4.5c-0.6-0.6-1.6-0.6-2.2,0 c-0.6,0.6-0.6,1.6,0,2.2L7.8,10l-3.3,3.3c-0.6,0.6-0.6,1.6,0,2.2C4.8,15.8,5.2,16,5.6,16s0.8-0.2,1.1-0.5l3.3-3.3l3.3,3.3c0.3,0.3,0.7,0.5,1.1,0.5s0.8-0.2,1.1-0.5c0.6-0.6,0.6-1.6,0-2.2L12.2,10z"/></svg>';
            selectedItem += '</span>';

            $("#divFacetGroup_" + this).html(selectedItem);
        });

        $("#tdFacetBox").removeClass("hide");
        $("#divSelectedCategories").removeClass("hide");
        $("#divCategories").removeClass("hide");
        $("#divFacets").show();
        $("#divCategories").show();

        if (facetSearchDataSession && facetSearchDataSession.LoadCookie) {
            facetSearchDataSession.LoadCookie = false;
            GetSearchResults(facetSearchDataSession.currentPage);
        }
        else {
            //get all search results starting from page 1
            GetSearchResults(1);
        }
    }
    $("ul.facetList li").each(function () {
        if ($(this).children("div").children().length === 1) {
            $(this).children("div").show();
            $(this).children().children(".triangleRight").addClass("triangleLeft").removeClass("triangleRight");
            $(this).attr("data-status", "open");
        }

        if ($(this).children("div").children('span').children('b').html() === "(0)"
            //|| $(this).children("div").children('span').children('b').html() == "(1)"
            ) {
            $(this).children("div").children('span').children('b').hide();
        }

        if ($(this).children("div").children('span').text().trim() === "No Results (0)") {
            $(this).children("div").children('span').removeAttr("onclick").removeClass("facetLinkMarginLeft").css("cursor", "text");
        }
    });

    if ($('#subscriptionBox').val() === "true")
        $(".subscriptionBox").css("display", "block");

    if (IsUserLoggedIn()) {
        $(".subscriptionBox a").attr("href", "/User-Management/Update-Registration/");
    }else {
        $(".subscriptionBox a").attr("href", "/User-Management/Member-Sign-In/");
    }

}

function FacetClicked(facet) {

    if (processingRequest) return;
    var facetPath = $(facet).data('path');
    var facetIndex = $(facet).data('findex');
    var facetName = $(facet).data('name');
    var facetGroupName = $(facet).data('gname');
    var facetGroupIndex = $(facet).data('gindex');

    var tempObject = new Object();
    tempObject.facetPath = $(facet).data('path');
    tempObject.facetIndex = $(facet).data('findex');
    tempObject.facetName = $(facet).data('name');
    tempObject.facetGroupName = $(facet).data('gname');
    tempObject.facetGroupIndex = $(facet).data('gindex');
    selectedFacetObjects.push(tempObject);

    selectedGroups.push(facetGroupIndex);
    selectedFacets.push(facetPath);

    if (selectedFacets.length === 1) {
        $('#divSelectedCategories').html('');
        //add the clear all link to facets list, only when the first facet is added
        var item = $('<br /><div class="facetLink" align="right" id="divFacetRemoveAll">' +
                'Clear All<span style="display:block; height:5px" /></div>')
                .show();

        $('#divSelectedCategories').append(item);
        //on click attach the event handler
        AttachDivFacetRemoveAllClickHandler();
        $(".clearFilter").css("display", "inline-block");
    }

    //add the clicked faced to selected facets list
    item = $('<div class="facetLink" data-facetpath="' + facetPath + '" data-gname="' + facetGroupName + '" data-name="' + facetName + '" data-gindex="' + facetGroupIndex + '" id="divSelected_' + facetIndex + '"><img src="/images/icons/delete.png" alt="Remove" /> ' +
                 '<b>' + facetName + '</b><span style="display:block; height:5px" /></div>')
                .show();

    $('#divSelectedCategories').prepend(item);

    //on click add the RemoveFacet event handler
    $('#divSelected_' + facetIndex).click(function () {
        RemoveFacet(facetIndex, facetPath);
    });

    $('.facetLink').click(function () {
        RemoveFacet($(this).data('facetindex'), $(this).data('facetpath'));
    });

    $(document).on('click', '.facetLinkMarginLeft', function () {
        RemoveFacet($(this).data('index') + "0", $(this).data('path'));
        if (selectedFacets.length === 0) {
            $(".clearFilter").css("display", "none");
        }
    });

    BindFacetsAndResults();

    LogAnalytics();
}

function RemoveFacet(facetIndex, facetPath) {
    if (processingRequest) return;

    var groupIndex = $('#divSelected_' + facetIndex).data('gindex');
    selectedGroups.splice($.inArray(groupIndex, selectedGroups), 1);

    $('#divSelected_' + facetIndex).remove();
    selectedFacets.splice($.inArray(facetPath, selectedFacets), 1);
    if (selectedFacets.length === 0) {
        $("#divSelectedCategories").html('<p>Your search can be refined using the categories below.</p>').show();
    }

    var spliceAt = -1;
    spliceAt = GetFacetObjectPosition(facetPath);
    if (spliceAt > -1)
        selectedFacetObjects.splice(spliceAt, 1);

    BindFacetsAndResults();
    LogAnalytics();
}

function AttachDivFacetRemoveAllClickHandler() {
    $('#divFacetRemoveAll,.clearFilter').click(function () {
        if (processingRequest) return;
        $("#divSelectedCategories").html('<p>Your search can be refined using the categories below.</p>').show();
        selectedFacets = new Array();
        selectedGroups = new Array();
        selectedFacetObjects = new Array();
        BindFacetsAndResults();
        LogAnalytics();
    });
}

function GetFacetObjectPosition(facetPath) {
    var spliceAt = -1;
    $.each(selectedFacetObjects, function (i, val) {
        if (val.facetPath === facetPath)
            spliceAt = i;
    });
    return spliceAt;
}

function GetSearchResults(currentPage) {
    ShowLoadingDialog();
    if (processingRequest) { return; }
    processingRequest = true;
    if (!searchText) searchText = '';
    var search = { Name: searchText, Value: searchType };
    var data = { "search": search, "selectedFacets": selectedFacets, "pageSize": pageSize, "currentPage": currentPage, "orderBy": orderBy };
    var cookieData = data;
    $.extend(cookieData, { "selectedFacetObjects": selectedFacetObjects }, { "selectedGroups": selectedGroups }, { "pathname": location.pathname }, { "LoadCookie": false });
    cookieData = JSON.stringify(cookieData);
    sessionStorage.FacetSearchData = cookieData;
    CallService("SearchSite", data, true, "SearchSiteComplete");
}

function SearchSiteComplete(result) {

    processingRequest = false;
    ShowNotification(result.notification);
    if (result.notification.NotificationType === 0) {
        processingRequest = false;
        $("#tdSearchContent").removeClass("hide");
        if (result.SearchSiteResult.length === 0) {
            //no search content
            $("#divActionButtons").hide();
            $("#searchResults").html('');
            $("#pager").hide();
            $("#divSearchNoResults").fadeIn('slow').removeClass("hide");
            HideLoadingDialog();
            return;
        }
        $("#divSearchNoResults").hide();
        $("#divActionButtons").show();
        $("#searchResults").html('');
        $("#searchResultsTemplate").tmpl(result.SearchSiteResult).appendTo("#searchResults").show();
        if (searchText !== '') {
            //bold the search text in search results. .highlight() is a jquery plugin, .highlight is defined as a class if style needs to be changed
            $("#searchResults").highlight(searchText);
            $(".searchedFor").css("display", "inline-block");
            $(".searchedFor").html("&nbsp;for&nbsp;<b>&#34;" + searchText + "&#34;</b>");
            $("#searchResults .typeCategory span").removeClass("highlight");

        } else {
            $(".searchedFor").css("display", "none");
        }

        $("#searchResults .article").each(function () {

            if ($(this).children('.typeCategory').text().trim().indexOf('Events') === -1 && $(this).children('.typeCategory').text().trim().indexOf('AIR in the News') === -1 && $(this).children('.summary').text().length > 250) {
                $(this).children('.summary').text($(this).children('.summary').text().trim().replace(/^(.{250}[^\s]*).*/, "$1"));
                $(this).children('.readMoreDots').removeClass('hide');
            }

            if (searchText !== '') {
                $(this).children('.summary').highlight(searchText);
            }
            $(this).removeClass("hide");
            $(this).next().removeClass("hide");
        });

        //set the pager control when setPagerControl is true
        if (setPagerControl) {
            SetTotalPages(result.pagingInfo._TotalPages);
            SetCurrentPage(result.pagingInfo._CurrentPage);
        }

        if (setTotalRecords) {
            $("#spanTotalRecords").html(result.pagingInfo._TotalRecords);
            setTotalRecords = false;
        }
    }
    HideLoadingDialog();

    $('html, body').animate({ scrollTop: 0 }, 100);
}

function GetList() {
    //GetList is called when the next, prev buttons are clicked from the pager control
    //we don't need to bind the pager control
    setPagerControl = false;
    GetSearchResults(currentPage);
    //scroll to the top. scrollTo is a plugin
    $.scrollTo($('#divForm'));
}

//function FacetSearchClicked() {
//    ShowLoadingDialog();
//    searchText = $.trim($("#txtFacetSearch").val());
//    searchText = searchText.replace(/(<([^>]+)>)/ig, "");

//    //whenever search button is clicked, sort results by relevancy
//    orderBy = { Name: 'relevancy', Value: 'desc' };
//    HighlightSortBy();

//    if (searchText != '') {
//        AddVirtualViewInAnalytics('/SearchResults?q=' + searchText);
//    }

//    //clear any of the previously selected facets and rebind results
//    $("#divSelectedCategories").html('<p>Your search can be refined using the categories below.</p>').show();
//    selectedFacets = new Array();
//    selectedGroups = new Array();
//    selectedFacetObjects = new Array();
//    ClearSearchDataCookie();
//    BindFacetsAndResults();
//}

function ChangePageSize(pSize, span) {
    $("#spanPageSize span").removeClass('highlightSelected').addClass("btn-default");
    $(span).addClass('highlightSelected').removeClass("btn-default");
    pageSize = pSize;
    //only set the pager control and get search results from page 1. No need to get the facets again since only the # of records per page is changing
    setPagerControl = true;
    GetSearchResults(1);
}

function ChangeSortOrder(oBy, span) {
    $("#spanSortOrder span").removeClass('highlightSelected').addClass("btn-default");
    $(span).addClass('highlightSelected').removeClass("btn-default");
    //orderBy = { Name: oBy, Value: 'desc' };
    //setPagerControl = true;
    //GetSearchResults(1);

    //var form = document.getElementById('frmSortOrder');
    //form.action = '/blog/search/?SelectedSortOrder = ' + oBy + ', BlogPostsFilter=' + '@Model.BlogPostsFilter' + 'PageNumber=' + '@Model.PageNumber';
    //form.submit();
}

function HighlightSortBy() {
    //$("#spanSortOrder span").removeClass('highlightSelected').addClass("btn-default");
    $("#spanSortOrder span").each(function () {
        if ($(this).data("searchby") === orderBy.Name.toLowerCase()) {
            $(this).siblings().removeClass('highlightSelected').addClass("btn-default");
            $(this).addClass('highlightSelected').removeClass("btn-default");
        }
    });
}

function StripHTML(text) {
    //return only the text from the html. Some of the html in cms is invalid
    var strippedHTML = $('<span>' + text + '</span>').text();
    return strippedHTML;
}

function BindFacetsAndResults() {
    //set the paging control to true so that it gets rebinded
    setPagerControl = true;
    setTotalRecords = true;
    //rebinds all facets
    GetFacets();
}

function ExpandHiddenDiv(span) {
    $(span).hide();
    $(span).next('div').slideDown('slow');
    $(span).remove();
}

function DisplayPublicationDate(publicationDate, typeCategory) {
    if (publicationDate === '' || searchType === "Events" || typeCategory.indexOf("Events |") !== -1)
        return '';
    else
        return '<p>' + publicationDate + '</p>';
}

function ShowLoginControl() {
    //show login control and hide the search results
    $("#pageContent").hide();
    window.location.href = "/User-Management/Member-Sign-In/?redirectUrl=" + location.href;
}

function LogAnalytics() {
    var url = '';
    if (searchType.toLowerCase() === 'keyword') {
        if (searchText === '') {
            url = '/SearchResults/';
        }
        else {
            url = '/SearchResults?q=' + searchText;
        }
    }
    else {
        url = location.pathname;
    }

    $($('div[id^="divSelected"]', '#divSelectedCategories').get().reverse()).each(function (idx, item) {
        var groupName = $(item).data('gname');
        var name = $(item).data('name');
        if (idx === 0 && searchText === '') {
            url += '?';
        }
        else {
            url += '&';
        }

        url += groupName + '=' + name;
    });

    AddVirtualViewInAnalytics(url);

}

function RetrieveCurrentUserInfoComplete(result) {
    if (result.Email === "" || result.Email === undefined || result.Email === null) {
        $("#divClientConfidentialTxt").css("display", "inline-block");
    }
    if (result.LoggedInButNoEloqua) {
        $("#divClientConfidentialTxt").css("display", "none");
    }
}